export const SurveyMedium = {
  APP: "APP",
  WEB: "WEB",
  SMS: "SMS",
};
